function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "19",
  fill: "#FFF",
  stroke: "#FABE28",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#353535",
  d: "M24.188 13.869h-1.48c-1.184 0-1.381.637-1.381 1.487v1.913h2.762l-.395 2.975h-2.367V28h-2.86v-7.756H16v-2.975h2.466v-2.231C18.367 12.38 19.847 11 22.017 11c.987 0 1.875.106 2.17.106v2.763z"
}))));